// IBAN bank registry — country -> entity code -> bank name.
// Plus country metadata (name, IBAN length, SEPA membership).
// Covers all 36 SEPA countries and the most common IBAN-supporting jurisdictions.

export const COUNTRY_META = {
  // SEPA zone
  AD: { name: "Andorra",           flag: "🇦🇩", len: 24, sepa: true },
  AT: { name: "Austria",           flag: "🇦🇹", len: 20, sepa: true },
  BE: { name: "Bélgica",           flag: "🇧🇪", len: 16, sepa: true },
  BG: { name: "Bulgaria",          flag: "🇧🇬", len: 22, sepa: true },
  HR: { name: "Croacia",           flag: "🇭🇷", len: 21, sepa: true },
  CY: { name: "Chipre",            flag: "🇨🇾", len: 28, sepa: true },
  CZ: { name: "Chequia",           flag: "🇨🇿", len: 24, sepa: true },
  DK: { name: "Dinamarca",         flag: "🇩🇰", len: 18, sepa: true },
  EE: { name: "Estonia",           flag: "🇪🇪", len: 20, sepa: true },
  FI: { name: "Finlandia",         flag: "🇫🇮", len: 18, sepa: true },
  FR: { name: "Francia",           flag: "🇫🇷", len: 27, sepa: true },
  DE: { name: "Alemania",          flag: "🇩🇪", len: 22, sepa: true },
  GR: { name: "Grecia",            flag: "🇬🇷", len: 27, sepa: true },
  HU: { name: "Hungría",           flag: "🇭🇺", len: 28, sepa: true },
  IS: { name: "Islandia",          flag: "🇮🇸", len: 26, sepa: true },
  IE: { name: "Irlanda",           flag: "🇮🇪", len: 22, sepa: true },
  IT: { name: "Italia",            flag: "🇮🇹", len: 27, sepa: true },
  LV: { name: "Letonia",           flag: "🇱🇻", len: 21, sepa: true },
  LI: { name: "Liechtenstein",     flag: "🇱🇮", len: 21, sepa: true },
  LT: { name: "Lituania",          flag: "🇱🇹", len: 20, sepa: true },
  LU: { name: "Luxemburgo",        flag: "🇱🇺", len: 20, sepa: true },
  MT: { name: "Malta",             flag: "🇲🇹", len: 31, sepa: true },
  MC: { name: "Mónaco",            flag: "🇲🇨", len: 27, sepa: true },
  NL: { name: "Países Bajos",      flag: "🇳🇱", len: 18, sepa: true },
  NO: { name: "Noruega",           flag: "🇳🇴", len: 15, sepa: true },
  PL: { name: "Polonia",           flag: "🇵🇱", len: 28, sepa: true },
  PT: { name: "Portugal",          flag: "🇵🇹", len: 25, sepa: true },
  RO: { name: "Rumanía",           flag: "🇷🇴", len: 24, sepa: true },
  SM: { name: "San Marino",        flag: "🇸🇲", len: 27, sepa: true },
  SK: { name: "Eslovaquia",        flag: "🇸🇰", len: 24, sepa: true },
  SI: { name: "Eslovenia",         flag: "🇸🇮", len: 19, sepa: true },
  ES: { name: "España",            flag: "🇪🇸", len: 24, sepa: true },
  SE: { name: "Suecia",            flag: "🇸🇪", len: 24, sepa: true },
  CH: { name: "Suiza",             flag: "🇨🇭", len: 21, sepa: true },
  GB: { name: "Reino Unido",       flag: "🇬🇧", len: 22, sepa: true },
  VA: { name: "Ciudad del Vaticano", flag: "🇻🇦", len: 22, sepa: true },
  // SWIFT-only (IBAN supported, outside SEPA)
  AE: { name: "Emiratos Árabes",   flag: "🇦🇪", len: 23, sepa: false },
  AL: { name: "Albania",           flag: "🇦🇱", len: 28, sepa: false },
  AZ: { name: "Azerbaiyán",        flag: "🇦🇿", len: 28, sepa: false },
  BH: { name: "Baréin",            flag: "🇧🇭", len: 22, sepa: false },
  BR: { name: "Brasil",            flag: "🇧🇷", len: 29, sepa: false },
  CR: { name: "Costa Rica",        flag: "🇨🇷", len: 22, sepa: false },
  DO: { name: "Rep. Dominicana",   flag: "🇩🇴", len: 28, sepa: false },
  GE: { name: "Georgia",           flag: "🇬🇪", len: 22, sepa: false },
  GI: { name: "Gibraltar",         flag: "🇬🇮", len: 23, sepa: false },
  GT: { name: "Guatemala",         flag: "🇬🇹", len: 28, sepa: false },
  IL: { name: "Israel",            flag: "🇮🇱", len: 23, sepa: false },
  JO: { name: "Jordania",          flag: "🇯🇴", len: 30, sepa: false },
  KW: { name: "Kuwait",            flag: "🇰🇼", len: 30, sepa: false },
  KZ: { name: "Kazajistán",        flag: "🇰🇿", len: 20, sepa: false },
  LB: { name: "Líbano",            flag: "🇱🇧", len: 28, sepa: false },
  MD: { name: "Moldavia",          flag: "🇲🇩", len: 24, sepa: false },
  ME: { name: "Montenegro",        flag: "🇲🇪", len: 22, sepa: false },
  MK: { name: "Macedonia del N.",  flag: "🇲🇰", len: 19, sepa: false },
  MR: { name: "Mauritania",        flag: "🇲🇷", len: 27, sepa: false },
  MU: { name: "Mauricio",          flag: "🇲🇺", len: 30, sepa: false },
  PK: { name: "Pakistán",          flag: "🇵🇰", len: 24, sepa: false },
  PS: { name: "Palestina",         flag: "🇵🇸", len: 29, sepa: false },
  QA: { name: "Catar",             flag: "🇶🇦", len: 29, sepa: false },
  RS: { name: "Serbia",            flag: "🇷🇸", len: 22, sepa: false },
  SA: { name: "Arabia Saudí",      flag: "🇸🇦", len: 24, sepa: false },
  SC: { name: "Seychelles",        flag: "🇸🇨", len: 31, sepa: false },
  TN: { name: "Túnez",             flag: "🇹🇳", len: 24, sepa: false },
  TR: { name: "Turquía",           flag: "🇹🇷", len: 26, sepa: false },
  UA: { name: "Ucrania",           flag: "🇺🇦", len: 29, sepa: false },
  XK: { name: "Kosovo",            flag: "🇽🇰", len: 20, sepa: false },
  EG: { name: "Egipto",            flag: "🇪🇬", len: 29, sepa: false },
  IQ: { name: "Iraq",              flag: "🇮🇶", len: 23, sepa: false },
  LY: { name: "Libia",             flag: "🇱🇾", len: 25, sepa: false },
  BY: { name: "Bielorrusia",       flag: "🇧🇾", len: 28, sepa: false },
  DZ: { name: "Argelia",           flag: "🇩🇿", len: 24, sepa: false },
  AO: { name: "Angola",            flag: "🇦🇴", len: 25, sepa: false },
  BJ: { name: "Benín",             flag: "🇧🇯", len: 28, sepa: false },
  BF: { name: "Burkina Faso",      flag: "🇧🇫", len: 27, sepa: false },
  BI: { name: "Burundi",           flag: "🇧🇮", len: 16, sepa: false },
  CM: { name: "Camerún",           flag: "🇨🇲", len: 27, sepa: false },
  CV: { name: "Cabo Verde",        flag: "🇨🇻", len: 25, sepa: false },
  CF: { name: "Rep. Centroafric.", flag: "🇨🇫", len: 27, sepa: false },
  TD: { name: "Chad",              flag: "🇹🇩", len: 27, sepa: false },
  KM: { name: "Comoras",           flag: "🇰🇲", len: 27, sepa: false },
  CG: { name: "Rep. del Congo",    flag: "🇨🇬", len: 27, sepa: false },
  CD: { name: "RD Congo",          flag: "🇨🇩", len: 27, sepa: false },
  CI: { name: "Costa de Marfil",   flag: "🇨🇮", len: 28, sepa: false },
  DJ: { name: "Yibuti",            flag: "🇩🇯", len: 27, sepa: false },
  GQ: { name: "Guinea Ecuatorial", flag: "🇬🇶", len: 27, sepa: false },
  GA: { name: "Gabón",             flag: "🇬🇦", len: 27, sepa: false },
  HN: { name: "Honduras",          flag: "🇭🇳", len: 28, sepa: false },
  MG: { name: "Madagascar",        flag: "🇲🇬", len: 27, sepa: false },
  ML: { name: "Mali",              flag: "🇲🇱", len: 28, sepa: false },
  MA: { name: "Marruecos",         flag: "🇲🇦", len: 28, sepa: false },
  MZ: { name: "Mozambique",        flag: "🇲🇿", len: 25, sepa: false },
  NE: { name: "Níger",             flag: "🇳🇪", len: 28, sepa: false },
  SN: { name: "Senegal",           flag: "🇸🇳", len: 28, sepa: false },
  TG: { name: "Togo",              flag: "🇹🇬", len: 28, sepa: false },
  // Local-network only (not IBAN — but accepted for SWIFT/correspondent banking)
  US: { name: "Estados Unidos",    flag: "🇺🇸", len: null, sepa: false },
  MX: { name: "México",            flag: "🇲🇽", len: null, sepa: false },
  AR: { name: "Argentina",         flag: "🇦🇷", len: null, sepa: false },
  CL: { name: "Chile",             flag: "🇨🇱", len: null, sepa: false },
  CO: { name: "Colombia",          flag: "🇨🇴", len: null, sepa: false },
  PE: { name: "Perú",              flag: "🇵🇪", len: null, sepa: false },
  CA: { name: "Canadá",            flag: "🇨🇦", len: null, sepa: false },
  AU: { name: "Australia",         flag: "🇦🇺", len: null, sepa: false },
  NZ: { name: "Nueva Zelanda",     flag: "🇳🇿", len: null, sepa: false },
  JP: { name: "Japón",             flag: "🇯🇵", len: null, sepa: false },
  CN: { name: "China",             flag: "🇨🇳", len: null, sepa: false },
  HK: { name: "Hong Kong",         flag: "🇭🇰", len: null, sepa: false },
  SG: { name: "Singapur",          flag: "🇸🇬", len: null, sepa: false },
  KR: { name: "Corea del Sur",     flag: "🇰🇷", len: null, sepa: false },
  IN: { name: "India",             flag: "🇮🇳", len: null, sepa: false },
  ZA: { name: "Sudáfrica",         flag: "🇿🇦", len: null, sepa: false },
  VE: { name: "Venezuela",         flag: "🇻🇪", len: null, sepa: false },
  EC: { name: "Ecuador",           flag: "🇪🇨", len: null, sepa: false },
  UY: { name: "Uruguay",           flag: "🇺🇾", len: null, sepa: false },
  PY: { name: "Paraguay",          flag: "🇵🇾", len: null, sepa: false },
  BO: { name: "Bolivia",           flag: "🇧🇴", len: null, sepa: false },
  PA: { name: "Panamá",            flag: "🇵🇦", len: null, sepa: false },
  CU: { name: "Cuba",              flag: "🇨🇺", len: null, sepa: false },
  NI: { name: "Nicaragua",         flag: "🇳🇮", len: null, sepa: false },
  SV: { name: "El Salvador",       flag: "🇸🇻", len: null, sepa: false },
  PR: { name: "Puerto Rico",       flag: "🇵🇷", len: null, sepa: false },
  ID: { name: "Indonesia",         flag: "🇮🇩", len: null, sepa: false },
  TH: { name: "Tailandia",         flag: "🇹🇭", len: null, sepa: false },
  VN: { name: "Vietnam",           flag: "🇻🇳", len: null, sepa: false },
  PH: { name: "Filipinas",         flag: "🇵🇭", len: null, sepa: false },
  MY: { name: "Malasia",           flag: "🇲🇾", len: null, sepa: false },
  TW: { name: "Taiwán",            flag: "🇹🇼", len: null, sepa: false },
  RU: { name: "Rusia",             flag: "🇷🇺", len: null, sepa: false },
  NG: { name: "Nigeria",           flag: "🇳🇬", len: null, sepa: false },
  KE: { name: "Kenia",             flag: "🇰🇪", len: null, sepa: false },
  GH: { name: "Ghana",             flag: "🇬🇭", len: null, sepa: false },
  ET: { name: "Etiopía",           flag: "🇪🇹", len: null, sepa: false },
  TZ: { name: "Tanzania",          flag: "🇹🇿", len: null, sepa: false },
  UG: { name: "Uganda",            flag: "🇺🇬", len: null, sepa: false },
};

// Country list for select dropdowns, sorted by SEPA membership then alphabetical
export const COUNTRY_LIST = Object.entries(COUNTRY_META)
  .map(([code, meta]) => ({ code, ...meta }))
  .sort((a, b) => (b.sepa - a.sepa) || a.name.localeCompare(b.name));

// Slice indices for the bank code inside the IBAN, per country
const BANK_CODE_SLICE = {
  ES: [4, 8], DE: [4, 12], FR: [4, 9], IT: [5, 10], PT: [4, 8],
  GB: [4, 8], NL: [4, 8], BE: [4, 7], AT: [4, 9], IE: [4, 8],
  LU: [4, 7], FI: [4, 10], CH: [4, 9], DK: [4, 8], SE: [4, 7],
  NO: [4, 8], PL: [4, 11], CZ: [4, 8], SK: [4, 8], HU: [4, 7],
  GR: [4, 7], RO: [4, 8], BG: [4, 8], HR: [4, 12], SI: [4, 6],
  EE: [4, 6], LV: [4, 8], LT: [4, 9], MT: [4, 8], CY: [4, 11],
  IS: [4, 8], LI: [4, 9], MC: [4, 9], SM: [4, 10], AD: [4, 8],
  // SWIFT zone with parseable bank codes
  TR: [4, 9], AE: [4, 7], SA: [4, 6], IL: [4, 7], EG: [4, 8],
  KW: [4, 8], QA: [4, 8], BH: [4, 8], JO: [4, 8], LB: [4, 8],
  TN: [4, 6], GE: [4, 6], UA: [4, 10], RS: [4, 7], AL: [4, 12],
  ME: [4, 7], MK: [4, 7], XK: [4, 8], BR: [4, 7],
};

export const BANK_REGISTRY = {
  ES: {
    "0049": "Banco Santander", "0182": "BBVA", "0081": "Banco Sabadell",
    "2100": "CaixaBank", "2038": "Bankia (CaixaBank)", "0128": "Bankinter",
    "0073": "Open Bank", "1465": "ING España", "1583": "Ibercaja Banco",
    "2080": "Abanca", "3035": "Laboral Kutxa", "0234": "Banco Caminos",
    "1538": "Evo Banco", "0238": "Banco Pichincha", "0019": "Deutsche Bank S.A.E.",
    "0061": "Banca March", "0083": "Renta 4 Banco", "1485": "OpenPayments",
    "1490": "Self Bank", "0058": "BNP Paribas España", "1491": "Triodos Bank",
    "0030": "Banesto (Santander)", "0042": "Banco Guipuzcoano",
    "0075": "Banco Popular (Santander)", "2085": "Ibercaja", "3025": "Caixa de Enginyers",
    "2048": "Liberbank (Unicaja)", "2103": "Unicaja Banco", "0186": "Banco Mediolanum",
    "1459": "Citibank España", "0162": "HSBC Bank plc, S.E.", "0152": "Barclays Bank S.A.",
    "1457": "bunq B.V., S.E.", "9000": "Banco de España",
  },
  DE: {
    "10070000": "Deutsche Bank", "37040044": "Commerzbank", "10020030": "DKB",
    "10090000": "Berliner Volksbank", "70150000": "Stadtsparkasse München",
    "20030000": "ING-DiBa", "76026000": "Sparda-Bank Nürnberg",
    "10011001": "N26 Bank", "10010010": "Postbank", "50050201": "Frankfurter Sparkasse",
    "20070024": "Deutsche Bank Hamburg", "30030880": "Targobank",
  },
  FR: {
    "30004": "BNP Paribas", "20041": "La Banque Postale", "30002": "Crédit Lyonnais (LCL)",
    "30003": "Société Générale", "30056": "HSBC France", "10907": "Crédit Agricole",
    "12579": "Crédit Mutuel", "16798": "Boursorama Banque", "11315": "BPCE",
    "12350": "Caisse d'Épargne", "13335": "Banque Populaire",
  },
  IT: {
    "03069": "Intesa Sanpaolo", "02008": "UniCredit", "01005": "BNL (BNP Paribas)",
    "05428": "Banco BPM", "03032": "Credito Emiliano", "03268": "Banca Sella",
    "08327": "Banca Mediolanum", "03104": "Hype (Banca Sella)",
    "05696": "Banca Popolare di Sondrio", "01030": "Monte dei Paschi di Siena",
  },
  PT: {
    "0010": "BPI", "0033": "Millennium BCP", "0035": "Caixa Geral de Depósitos",
    "0007": "Novo Banco", "0036": "Santander Totta", "0079": "Banco Best",
    "0193": "Banco CTT", "0008": "Banco BIC",
  },
  GB: {
    "BARC": "Barclays", "HBUK": "HSBC", "LOYD": "Lloyds Bank",
    "REVO": "Revolut", "MONZ": "Monzo", "TSBS": "TSB", "NWBK": "NatWest",
    "RBOS": "Royal Bank of Scotland", "MIDL": "HSBC UK", "ABBY": "Santander UK",
    "BUKB": "Barclays Bank UK", "STAR": "Starling Bank", "CPBK": "Cooperative Bank",
  },
  NL: {
    "INGB": "ING", "ABNA": "ABN AMRO", "RABO": "Rabobank", "BUNQ": "bunq",
    "TRIO": "Triodos Bank", "SNSB": "SNS Bank", "ASNB": "ASN Bank",
    "RBRB": "RegioBank", "KNAB": "Knab",
  },
  BE: {
    "001": "BNP Paribas Fortis", "310": "ING Belgium", "734": "KBC Bank",
    "035": "Belfius", "523": "Crédit Agricole", "001": "Argenta",
    "853": "Beobank", "979": "AXA Bank",
  },
  AT: {
    "20111": "Erste Bank", "11000": "Bank Austria (UniCredit)", "12000": "BAWAG P.S.K.",
    "32000": "Raiffeisenlandesbank NÖ-Wien", "19431": "Hypo Tirol Bank",
    "60000": "Easybank",
  },
  IE: {
    "AIBK": "AIB", "BOFI": "Bank of Ireland", "ULSB": "Ulster Bank",
    "IPBS": "Permanent TSB", "REVO": "Revolut Bank Ireland",
  },
  LU: {
    "002": "BCEE (Spuerkeess)", "003": "BGL BNP Paribas", "004": "Banque et Caisse",
    "005": "ING Luxembourg", "012": "Banque Internationale", "001": "Citibank Europe",
    "030": "Société Générale BT",
  },
  FI: {
    "100000": "Nordea", "200000": "Nordea Bank", "405000": "OP Pohjola",
    "713000": "Danske Bank", "799999": "Banking", "335000": "Handelsbanken",
  },
  CH: {
    "00770": "UBS", "00230": "Credit Suisse", "00782": "Raiffeisen Schweiz",
    "00277": "PostFinance", "08387": "Bank Julius Bär", "00781": "Migros Bank",
  },
  DK: {
    "30000": "Danske Bank", "20000": "Nordea Danmark", "76800": "Jyske Bank",
    "53010": "Sydbank", "53050": "Spar Nord Bank",
  },
  SE: {
    "5000": "SEB", "6000": "Handelsbanken", "8000": "Swedbank",
    "9000": "Nordea Sverige", "9020": "Länsförsäkringar Bank",
  },
  NO: {
    "12000": "DNB", "70000": "Sparebanken", "63450": "Nordea Norge",
    "97500": "Sbanken (DNB)",
  },
  PL: {
    "10500099": "ING Bank Śląski", "11402004": "mBank", "10901043": "Santander Bank Polska",
    "16001462": "BNP Paribas Polska", "11602202": "Bank Millennium",
    "12404027": "Bank Pekao",
  },
  GR: {
    "0110": "National Bank of Greece", "0140": "Alpha Bank", "0172": "Eurobank",
    "0171": "Piraeus Bank",
  },
  CZ: {
    "01000": "ČNB", "01005": "ČSOB", "02700": "UniCredit Bank Czech",
    "03000": "Československá obchodní banka", "08000": "Česká spořitelna",
  },
  IS: {
    "01010": "Landsbankinn", "05150": "Arion Banki", "05131": "Íslandsbanki",
  },
  RO: {
    "BTRL": "Banca Transilvania", "BRDE": "BRD-Société Générale",
    "RNCB": "BCR Erste", "BACX": "UniCredit Bank Romania",
  },
  MT: {
    "MMEB": "Bank of Valletta", "VALL": "Bank of Valletta", "MALT": "HSBC Bank Malta",
    "APSB": "APS Bank Malta", "LBMM": "Lombard Bank Malta",
    "BNIF": "BNF Bank Malta", "FCMB": "FCM Bank",
    "CFTE": "Finaro (ex-Credorax)", "AKBK": "Akbank T.A.S. Malta",
    "MEDB": "MeDirect Bank Malta", "FIMB": "FIMBank plc",
    "FBOM": "FBME Bank Malta", "PAYD": "OpenPayd Financial Services Malta",
    "EUBL": "EuroBank Cyprus Malta branch",
  },
  CY: {
    "002": "Bank of Cyprus", "007": "Hellenic Bank", "003": "Astrobank",
    "005": "Eurobank Cyprus", "020": "Alpha Bank Cyprus", "017": "RCB Bank",
  },
  LU: {
    "001": "Citibank Europe Luxembourg", "002": "BCEE (Spuerkeess)",
    "003": "BGL BNP Paribas", "004": "Banque et Caisse",
    "005": "ING Luxembourg", "006": "Banque Internationale à Luxembourg",
    "012": "Banque Internationale", "030": "Société Générale BT",
  },
  LV: {
    "HABA": "Swedbank Latvia", "RIKO": "Citadele banka", "PARX": "Rietumu Banka",
    "UNLA": "SEB banka Latvija", "NDEA": "Luminor Bank Latvia",
  },
  LT: {
    "73000": "Swedbank Lietuva", "70440": "SEB bankas", "72400": "Šiaulių bankas",
    "21400": "Luminor Bank Lithuania", "32100": "Citadele bankas",
  },
  EE: {
    "10": "Swedbank Estonia", "22": "SEB Pank", "75": "Luminor Bank Estonia",
    "77": "LHV Pank", "33": "Coop Pank",
  },
  HU: {
    "1177": "OTP Bank", "1170": "K&H Bank (KBC)", "1209": "MKB Bank",
    "1040": "UniCredit Bank Hungary", "1090": "Erste Bank Hungary",
  },
  SK: {
    "0900": "Slovenská sporiteľňa", "0200": "VÚB Banka", "1100": "Tatra banka",
    "8330": "Fio banka Slovakia", "1111": "UniCredit Bank Slovakia",
  },
  SI: {
    "020": "NLB", "030": "SKB banka", "041": "Nova KBM",
    "061": "Abanka", "100": "Banka Sparkasse Slovenija",
  },
  HR: {
    "23600000": "Zagrebačka banka (UniCredit)", "24840008": "Raiffeisenbank Austria HR",
    "25030007": "Splitska banka (OTP)", "23400009": "Privredna banka Zagreb",
    "23900001": "Hrvatska poštanska banka",
  },
  BG: {
    "BNBG": "Bulgarian National Bank", "DSKB": "DSK Bank (OTP Group)",
    "UBBS": "United Bulgarian Bank", "FINV": "First Investment Bank",
    "BUIB": "Bulbank (UniCredit Bulbank)", "STSA": "Société Générale Expressbank",
  },
  TR: {
    "00046": "Akbank", "00010": "Türkiye İş Bankası", "00012": "Türkiye Vakıflar Bankası",
    "00067": "Yapı Kredi Bankası", "00064": "QNB Finansbank", "00134": "Denizbank",
    "00109": "Türkiye Halk Bankası", "00062": "Garanti BBVA",
    "00138": "TEB (BNP Paribas)", "00146": "Odeabank",
  },
  AE: {
    "030": "Emirates NBD", "022": "Abu Dhabi Commercial Bank (ADCB)",
    "026": "Mashreq Bank", "020": "First Abu Dhabi Bank (FAB)",
    "021": "RAK Bank", "120": "Wio Bank",
  },
  SA: {
    "10": "National Commercial Bank (Saudi National Bank)", "20": "Riyad Bank",
    "30": "Banque Saudi Fransi", "40": "SABB (HSBC)",
    "60": "Al Rajhi Bank", "80": "Arab National Bank",
  },
  IL: {
    "010": "Bank Leumi", "011": "Discount Bank", "012": "Bank Hapoalim",
    "031": "Bank Hapoalim B.M.", "017": "Mercantile Discount Bank",
    "020": "Bank Yahav",
  },
  BR: {
    "001": "Banco do Brasil", "104": "Caixa Econômica Federal", "033": "Santander Brasil",
    "237": "Bradesco", "341": "Itaú Unibanco", "260": "Nu Pagamentos (Nubank)",
    "212": "Banco Original", "077": "Banco Inter", "336": "C6 Bank",
    "208": "Banco BTG Pactual", "422": "Banco Safra",
  },
  RS: {
    "265": "Raiffeisen banka Serbia", "160": "Banca Intesa Beograd",
    "330": "Komercijalna banka", "275": "Société Générale Srbija",
    "150": "Erste Bank Serbia",
  },
  UA: {
    "300012": "Privatbank", "320478": "Oschadbank", "300335": "Raiffeisen Bank Ukraine",
    "351005": "Ukrsibbank (BNP Paribas)", "380805": "OTP Bank Ukraine",
  },
  EG: {
    "0001": "Central Bank of Egypt", "0003": "National Bank of Egypt",
    "0004": "Banque Misr", "0011": "QNB Alahli",
    "0037": "Commercial International Bank (CIB)", "0010": "HSBC Bank Egypt",
  },
  GE: {
    "BG": "Bank of Georgia", "TB": "TBC Bank", "LB": "Liberty Bank",
    "BA": "Basisbank", "VT": "VTB Bank Georgia",
  },
  AL: {
    "20211008": "Banka Kombëtare Tregtare (BKT)", "20810016": "Raiffeisen Bank Albania",
    "21200013": "Intesa Sanpaolo Bank Albania", "20210009": "Tirana Bank",
  },
  ME: {
    "510": "CKB - Crnogorska komercijalna banka (OTP)",
    "520": "Hipotekarna banka", "907": "Erste Bank Crna Gora",
    "535": "Universal Capital Bank",
  },
  XK: {
    "1101": "Raiffeisen Bank Kosovo", "1303": "Banka Kombëtare Tregtare Kosovo",
    "1701": "ProCredit Bank Kosovo", "1908": "TEB SH.A. Kosovo",
  },
};

export const BANK_BRANDS = {
  "Banco Santander": "#EC0000", "BBVA": "#1464A5", "CaixaBank": "#1973B8",
  "Banco Sabadell": "#005EB8", "Bankinter": "#FF6F00", "ING España": "#FF6200",
  "OpenPayments": "#7C3AED", "Revolut": "#0666EB", "Monzo": "#FF3464",
  "bunq": "#231F20", "BNP Paribas": "#00915A", "Commerzbank": "#FFCC00",
  "Deutsche Bank": "#0018A8", "HSBC": "#DB0011", "Barclays": "#00AEEF",
  "Lloyds Bank": "#024731", "N26 Bank": "#26F0AF", "Starling Bank": "#7433FF",
  "ABN AMRO": "#FFD200", "ING": "#FF6200", "Rabobank": "#FF6300",
  "UBS": "#E60000", "Credit Suisse": "#1F4587", "Nordea": "#00005E",
  "Erste Bank": "#0033A0", "Intesa Sanpaolo": "#5C2D91", "UniCredit": "#E2001A",
  "BPI": "#0072CE", "Millennium BCP": "#003366", "AIB": "#005EB8",
  "Bank of Ireland": "#005EB8", "Crédit Agricole": "#009639",
  "Société Générale": "#E60000", "DNB": "#007D2E", "Danske Bank": "#003755",
  "SEB": "#60BE3A", "Handelsbanken": "#005A8C", "Swedbank": "#FF6200",
};

function mod97(iban) {
  const rearranged = iban.slice(4) + iban.slice(0, 4);
  let num = "";
  for (const ch of rearranged) {
    num += /\d/.test(ch) ? ch : (ch.toUpperCase().charCodeAt(0) - 55).toString();
  }
  let rem = 0;
  for (const d of num) rem = (rem * 10 + Number(d)) % 97;
  return rem;
}

export function validateIban(input) {
  const iban = (input || "").replace(/\s+/g, "").toUpperCase();
  if (!iban) return { valid: false, reason: "Vacío", iban: "" };
  if (iban.length < 15 || !/^[A-Z]{2}/.test(iban) || !/^\d{2}/.test(iban.slice(2, 4))) {
    return { valid: false, reason: "Formato inválido", iban };
  }
  const country = iban.slice(0, 2);
  const meta = COUNTRY_META[country];
  if (!meta || meta.len === null) {
    return { valid: false, reason: `País IBAN no soportado (${country})`, iban, country };
  }
  if (iban.length !== meta.len) {
    return { valid: false, reason: `Longitud incorrecta para ${meta.name} (esperado ${meta.len})`, iban, country, country_name: meta.name };
  }
  if (mod97(iban) !== 1) {
    return { valid: false, reason: "Checksum inválido", iban, country, country_name: meta.name };
  }
  // Bank detection
  let bank_code = "";
  let bank_name = `Entidad ${meta.name}`;
  const slice = BANK_CODE_SLICE[country];
  if (slice) {
    bank_code = iban.slice(slice[0], slice[1]);
    bank_name = (BANK_REGISTRY[country] || {})[bank_code] || `Entidad ${meta.name}`;
  }
  return {
    valid: true,
    iban,
    country,
    country_name: meta.name,
    country_flag: meta.flag,
    sepa: meta.sepa,
    bank_code,
    bank_name,
    network: meta.sepa ? "SEPA" : "SWIFT",
  };
}

// Argentina — CBU bank codes (first 3 digits) + CVU virtual wallets (first 7 digits)
export const AR_BANKS = {
  "005": "Banco Galicia", "007": "Banco Galicia (HSBC)",
  "011": "Banco Nación", "014": "Banco Provincia de Buenos Aires",
  "015": "Banco ICBC", "016": "Banco Citibank Argentina",
  "017": "Banco BBVA Argentina", "018": "Banco Citibank N.A.",
  "020": "Banco de la Pampa", "027": "Banco Supervielle",
  "029": "Banco Ciudad de Buenos Aires", "034": "Banco Patagonia",
  "044": "Banco Hipotecario", "045": "Banco de San Juan",
  "046": "JPMorgan Chase Bank", "060": "Banco del Tucumán",
  "065": "Banco Municipal de Rosario", "072": "Banco Santander Río",
  "083": "Banco del Chubut", "086": "Banco de Santa Cruz",
  "093": "Banco Corrientes", "094": "Banco Provincia del Neuquén",
  "097": "Banco Provincia de Tierra del Fuego",
  "143": "Brubank", "147": "BIBank (ex-Itaú)",
  "150": "HSBC Bank Argentina (Galicia)", "165": "JP Morgan",
  "191": "Banco Credicoop", "198": "Banco de Valores",
  "247": "Banco Roela", "254": "Banco Mariva",
  "259": "Banco Itaú Argentina", "262": "Banco Provencred",
  "266": "Banco BNP Paribas", "268": "Banco Provincia de Tierra del Fuego",
  "269": "Banco República Oriental del Uruguay",
  "277": "Banco Sáenz", "281": "Banco Meridian",
  "285": "Banco Macro", "295": "American Express Bank",
  "299": "Banco Coinag", "300": "BICE",
  "301": "Banco Comafi", "305": "Banco Cetelem Argentina",
  "309": "Nuevo Banco de La Rioja", "310": "Banco del Sol",
  "311": "Nuevo Banco del Chaco", "312": "Banco VW Credit",
  "315": "Banco de Formosa", "319": "Banco CMF",
  "321": "Banco de Santiago del Estero", "322": "Banco Industrial",
  "330": "Nuevo Banco de Santa Fe", "331": "Banco Cetelem Argentina",
  "332": "Banco de Servicios Financieros", "336": "Banco Bradesco Argentina",
  "338": "Banco de Servicios y Transacciones", "339": "RCI Banque",
  "340": "BACS Banco de Crédito y Securitización", "341": "Banco Más Ventas",
  "384": "Wilobank", "386": "Nuevo Banco de Entre Ríos",
  "389": "Banco Columbia", "405": "Bank of China",
  "426": "Banco BICA", "431": "Banco Coinag",
  "432": "Banco de Comercio", "434": "Banco Piano",
  "437": "Banco Voii", "438": "Banco Itaú Argentina",
  "448": "Banco Dino", "453": "Banco Sucredito Regional",
  "456": "Banco Mercurio", "457": "Banco BACS",
};

export const AR_CVU_ENTITIES = {
  "0000003": "Mercado Pago", "0000004": "Mercado Pago",
  "0000007": "Naranja X", "0000008": "Belo",
  "0000011": "Cuenta DNI · Banco Provincia",
  "0000020": "Ualá", "0000031": "Brubank",
  "0000035": "Pomelo", "0000037": "Personal Pay",
  "0000038": "MODO", "0000043": "Lemon Cash",
  "0000044": "Buenbit", "0000048": "Prex",
  "0000050": "Tap", "0000055": "Reba",
  "0000067": "Astropay", "0000071": "Yacaré",
  "0000072": "Increase", "0000074": "PrismaPay",
  "0000079": "Ank", "0000087": "BIND",
  "0000110": "Cuenta DNI", "0000133": "Pomelo",
  "0000142": "MEP", "0000143": "Bitso",
  "0000165": "Lemon Cash", "0000168": "Ripio",
  "0000172": "Plus Pagos", "0000204": "Pomelo",
};

function _arBlockChecksum(block, weights) {
  let total = 0;
  for (let i = 0; i < weights.length; i++) total += parseInt(block[i], 10) * weights[i];
  const check = (10 - (total % 10)) % 10;
  return check === parseInt(block[block.length - 1], 10);
}

export function validateCBU(value) {
  const s = (value || "").replace(/[\s-]/g, "");
  if (!/^\d{22}$/.test(s)) return { valid: false, reason: "El CBU/CVU debe tener 22 dígitos numéricos", cbu: s };
  if (!_arBlockChecksum(s.slice(0, 8), [7, 1, 3, 9, 7, 1, 3])) {
    return { valid: false, reason: "Checksum del bloque 1 inválido", cbu: s };
  }
  if (!_arBlockChecksum(s.slice(8), [3, 9, 7, 1, 3, 9, 7, 1, 3, 9, 7, 1, 3])) {
    return { valid: false, reason: "Checksum del bloque 2 inválido", cbu: s };
  }
  const bankCode3 = s.slice(0, 3);
  if (bankCode3 === "000") {
    const entity = s.slice(0, 7);
    return {
      valid: true, kind: "CVU",
      bank_code: entity, bank_name: AR_CVU_ENTITIES[entity] || "Billetera virtual (CVU)",
      country: "AR", country_name: "Argentina", country_flag: "🇦🇷",
      network: "CVU", branch_code: s.slice(7, 11), account: s.slice(11), cbu: s,
    };
  }
  return {
    valid: true, kind: "CBU",
    bank_code: bankCode3, bank_name: AR_BANKS[bankCode3] || `Entidad argentina (${bankCode3})`,
    country: "AR", country_name: "Argentina", country_flag: "🇦🇷",
    network: "CBU", branch_code: s.slice(3, 7), account: s.slice(8, 21), cbu: s,
  };
}

export function detectCategory(description = "") {
  const d = description.toLowerCase();
  if (/(salario|nómina|payroll|salary)/i.test(d)) return { key: "salary", label: "Salario", color: "#16A34A", bg: "#DCFCE7" };
  if (/(supermercado|carrefour|mercadona|lidl|dia|aldi)/i.test(d)) return { key: "grocery", label: "Supermercado", color: "#EA580C", bg: "#FFEDD5" };
  if (/(netflix|spotify|amazon prime|hbo|disney|youtube)/i.test(d)) return { key: "subs", label: "Suscripción", color: "#9333EA", bg: "#F3E8FF" };
  if (/(café|starbucks|coffee|restaurante|uber eats|just eat|glovo)/i.test(d)) return { key: "food", label: "Comida", color: "#DB2777", bg: "#FCE7F3" };
  if (/(transferencia|transfer)/i.test(d)) return { key: "transfer", label: "Transferencia", color: "#2563EB", bg: "#DBEAFE" };
  if (/(reembolso|refund)/i.test(d)) return { key: "refund", label: "Reembolso", color: "#0891B2", bg: "#CFFAFE" };
  if (/(depósito|deposit)/i.test(d)) return { key: "deposit", label: "Depósito", color: "#16A34A", bg: "#DCFCE7" };
  if (/(amazon|el corte inglés|aliexpress)/i.test(d)) return { key: "shopping", label: "Compras", color: "#7C3AED", bg: "#EDE9FE" };
  return { key: "other", label: "Otros", color: "#475569", bg: "#F1F5F9" };
}
